import { $authHost } from "../../http";
import { 
    PROBE_STATE_GET_REQUEST, PROBE_STATE_GET_SUCCESS, PROBE_STATE_GET_ERROR, 
    PROBE_STATE_GET_BY_KEY_REQUEST, PROBE_STATE_GET_BY_KEY_SUCCESS, PROBE_STATE_GET_BY_KEY_ERROR, 
    PROBE_STATE_ADD_REQUEST, PROBE_STATE_ADD_SUCCESS, PROBE_STATE_ADD_ERROR, 
    PROBE_STATE_EDIT_REQUEST, PROBE_STATE_EDIT_SUCCESS, PROBE_STATE_EDIT_ERROR, 
    PROBE_STATE_DELETE_REQUEST, PROBE_STATE_DELETE_SUCCESS, PROBE_STATE_DELETE_ERROR
} from "../constants/probeStateConstants";

export const getProbeStates = (args) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_STATE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/probeState/query",
            args || {},
            config,
        );
        dispatch({
            type: PROBE_STATE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PROBE_STATE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getProbeStateByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_STATE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/probeState/${id}`,
        );
        dispatch({
            type: PROBE_STATE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PROBE_STATE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addProbeState = ({ name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_STATE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/probeState",
            { name, code },
            config,
        );
        dispatch(getProbeStates(queryArgs || {}));
        dispatch({
            type: PROBE_STATE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PROBE_STATE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editProbeState = ({ id, name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_STATE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/probeState",
            { id, name, code },
            config,
        );
        dispatch(getProbeStates(queryArgs || {}));
        dispatch({
            type: PROBE_STATE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PROBE_STATE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteProbeState = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_STATE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/probeState",
            { data: { id } },
            config,
        );
        dispatch(getProbeStates(queryArgs || {}));
        dispatch({
            type: PROBE_STATE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PROBE_STATE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

